import { EditorMiddleware } from '@picsart/design-system/components/EditorMiddleware';

import useStyles from './styles';
import type { AppLayoutProps } from './types';

/**
 * Root shell for both viewports, built on `EditorMiddleware` — the DS template
 * that owns the root-entry environment (meta viewport, editor root height,
 * pull-to-refresh and zoom suppression) via `__isRootEntryElement`.
 *
 * Mobile used to use `EditorBlank`, which DS v13 replaced with `Blank`. `Blank`
 * spreads its `header` prop into a `PanelHeading` and drops `className`, so it
 * can no longer host this app's custom `<Header>`. The mobile branch keeps the
 * old `auto 1fr` header/body grid locally instead; `isWidthLimitDisabled`
 * preserves `EditorBlank`'s behaviour of not enforcing a window min-width.
 */
const AppLayout = ({
  header,
  children,
  className,
  isMobile,
}: AppLayoutProps) => {
  const classes = useStyles();

  if (isMobile) {
    return (
      <EditorMiddleware
        __isRootEntryElement
        isWidthLimitDisabled
        className={className}
        slot={
          <div className={classes.mobile}>
            {header}
            {children}
          </div>
        }
      />
    );
  }

  return (
    <EditorMiddleware
      __isRootEntryElement
      className={className}
      slot={
        <div className={classes.desktop}>
          {header}
          {children}
        </div>
      }
    />
  );
};

export default AppLayout;
